<template>
    <Modal title="订单详情" :width="1400" @on-visible-change="showModal" v-model="show" :closable="false" :mask-closable="false">
        <div>
            <Steps :current="current" :status="status">
                <Step title="待付款"></Step>
                <Step title="卖家处理中"></Step>
                <Step title="待出货"></Step>
                <Step title="运送中"></Step>
                <Step title="确认收货"></Step>
                <Step title="已完成"></Step>
                <Step title="取消中"></Step>
                <Step title="已取消"></Step>
                <Step title="退款中"></Step>
            </Steps>
            <el-row :gutter="16" style="margin-top: 20px">
                <el-col :span="8">
                <el-card style="height: 220px">
                    <p slot="header">
                        <i class="ios-film-outline"></i>
                        基本信息
                    </p>
                    <ul class="orderdetailinfo">
                        <li>店铺：{{order.shopName}}</li>
                        <li>订单号：{{order.ordersn}}</li>
                        <li>物流方式：{{order.shippingCarrier}}</li>
                        <li>出货时间：{{order.shipByDate|long2datetime}}</li>
                    </ul>
                </el-card> 
                </el-col>
                <el-col :span="8">
                <el-card style="height: 220px">
                    <p slot="header">
                        <i class="ios-film-outline"></i>
                        时间
                    </p>
                    <ul class="orderdetailinfo">
                        <li>下单时间：{{order.createTime|long2datetime}}</li>
                        <li v-if="order.payTime">付款时间：{{order.payTime|long2datetime}}</li>
                        <li v-if="order.orderStatus=='COMPLETED'">完成时间：{{order.updateTime|long2datetime}}</li>
                        <li v-if="order.orderStatus=='CANCELLED'">取消时间：{{order.updateTime|long2datetime}}</li>
                        <li>更新时间：{{order.updateTime|long2datetime}}</li>
                    </ul>
                </el-card> 
                </el-col>
                <el-col :span="8">
                <el-card style="height: 220px">
                    <p slot="header">
                        <i class="ios-film-outline"></i>
                        买家信息
                    </p>
                    <ul class="orderdetailinfo">
                        <li>虾皮号：{{order.buyerUsername}}</li>
                        <li>收件人：{{order.name}}</li>
                        <li>手机号码：{{order.phone}}</li>
                        <li>收货地址：{{order.fullAddress}}</li>
                    </ul>
                    <el-button size="small" @click="getFullname" type="success" :loading="fullLoading">查看信息</el-button>
                </el-card> 
                </el-col>
            </el-row>
            <el-row :gutter="16" style="margin-top: 20px">
                <Tabs value="name2">
                    <TabPane label="商品信息" name="name2">
                        <div v-for="(product,ind) in order.itemMaps">
                            <div class="orderitem">
                                <div class="item-images">
                                    <img :src="product.image" @click="imgName=product.image;visible=true;">
                                </div>
                                <div class="item-product">
                                    <div class="order-name">
                                        <a v-if="order.country=='TW'" target="_blank" :href="'https://xiapi.xiapibuy.com/product/'+order.shopId+'/'+product.itemId">{{product.itemName}}</a>
                                        <a v-else target="_blank" :href="'https://'+order.country+'.xiapibuy.com/product/'+order.shopId+'/'+product.itemId">{{product.itemName}}</a>
                                    </div>
                                    <div class="order-attr">
                                        规格：{{product['variationName']}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane label="货代信息" name="name1" v-if="order.splitUp==0">
                        <Steps :current="waybillCurrent" :status="waybillStatus" style="margin-bottom: 15px">
                            <Step title="商家审核中"></Step>
                            <Step title="签收中"></Step>
                            <Step title="待出库"></Step>
                            <Step title="已出库"></Step>
                            <Step title="本土已签收"></Step>
                            <Step title="已取消">{{order.cpwaybill && order.cpwaybill!=null && order.cpwaybill.list && order.cpwaybill.list.length>0}}</Step>
                        </Steps>
                        <template v-if="order.cpwaybill && order.cpwaybill!=null && order.cpwaybill.list && order.cpwaybill.list.length>0">
                            <div v-for="(express,ind) in order.cpwaybill.list" class="express-item">
                                <div class="sm-express-item-images">
                                    <img :src="express.pictures[0]" />
                                    <div class="sm-express-item-image-cover" @click="carouselShow" :data-pics="express.pics">
                                        共有{{express.pictures.length}}图片
                                    </div>
                                </div>
                                <div class="sm-express-item-product">
                                    <div class="sm-express-item-name">
                                        {{express.remark}}
                                    </div>
                                    <div class="sm-express-item-attr">
                                        <template v-if="express.type==2"> 库存单</template>
                                        <template v-else>
                                            <template v-if="express.fillIn==1">
                                                单号：<a target="_blank" :href="'https://www.baidu.com/s?wd='+express.expressNo">{{express.expressNo}}</a>
                                            </template>
                                            <template v-else>未发货</template>
                                        </template>
                                    </div>
                                    <div class="sm-express-item-attr" v-if="express.wareRemark">
                                        仓库备注:{{express.wareRemark}}
                                    </div>
                                    <div class="sm-express-item-op">
                                        <span v-if="express.state==1" class="state-success-full">已签收</span>
                                        <span v-if="express.state==-1" class="state-error-full">拒签退回</span>
                                        <span v-if="express.state==-2" class="state-error-full">已取消</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div v-else>
                            <el-alert >暂未添加快递包裹</el-alert>
                        </div>
                    </TabPane>
                    <TabPane label="拆分订单" name="name5" v-else>
                        升级中....
                    </TabPane>
                    <TabPane label="买家备注" name="name3">
                        <el-alert  v-if="order.messageToSeller">{{order.messageToSeller}}</el-alert>
                        <el-alert  v-else>暂无备注</el-alert>
                    </TabPane>
                </Tabs>
            </el-row>
        </div>
        <div slot="footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" @click="ok">重新加载</el-button>
        </div>
        <Modal title="快递内商品图" v-model="carouseVisible" :width="400">
            <Carousel v-if="carouseVisible" v-model="imageIndex" :loop="false">
                <CarouselItem v-for="(pics,ind) in images" :key="ind">
                    <img :src="pics" class="ep" />
                </CarouselItem>
            </Carousel>
        </Modal>
        <Modal v-model="visible" :width="800">
            <img :src="imgName" v-if="visible" style="width: 100%">
        </Modal>
    </Modal>
</template>
<script>
import Constants from "@/utils/constants.js"
export default {
    name: "",
    data() {
        return {
            fullLoading:false,
            carouseVisible: false,
            imageIndex: 0,
            images: [],
            imgName: "",
            visible: false,
            loading: false,
            show: false,
            current: 1,
            waybillCurrent: 1,
            waybillStatus: "process",
            status: "process",
            order: {
                cpwaybill: [],
                itemMaps: []
            }

        }
    },
    props: [
        'ordersn'
    ],
    watch: {
        current: {
            handler(newval, oldval) {
                if (newval > 5) this.status = "error";
                else if (newval == 5) this.status = "finish";
                else this.status = "process";

            }
        },
        waybillCurrent: {
            handler(newval, oldval) {

                if (newval > 0 && newval <= 2) this.waybillStatus = "process";
                else if (newval < 5 && newval > 2) this.waybillStatus = "finish";
                else this.waybillStatus = "error";


            }
        }
    },
    methods: {
        getFullname: function() {
            this.fullLoading=true;
            this.$http.post("/ware/waybill/getLogistiscInfo.action", {
                    ordersn:this.ordersn
            }).then(response => {
                    this.fullLoading=false;
                    if(response.status==0){
                        this.order.name=response.obj.name;
                        this.order.phone=response.obj.phone;
                        this.order.fullAddress=response.obj.fullAddress;
                    }
                    else{
                        this.errorMessage(response.info);
                    }
            }, response => {
                    this.fullLoading=false;
            });

        },
        carouselShow: function(e) {
            this.images = e.currentTarget.dataset.pics.split("##").filter(titem => titem != '');
            this.imageIndex = 0;
            this.carouseVisible = true;
        },
        showDialog() {
            this.show = true;
        },
        showModal(val) {
            if (val && this.ordersn) {
                this.ok();
            } else {

            }
        },
        ok: function() {
            var me = this;
            me.loading = true;
            me.showLoading();
            me.$http.post("/ware/waybill/showorder.action", { ordersn: me.ordersn }).then(response => {
                var body = response;
                me.loading = false;
                if (body.status == 0) {

                    if (body.obj.cpwaybill && body.obj.cpwaybill.list) {
                        for (var i = 0; i < body.obj.cpwaybill.list.length; i++) {

                            body.obj.cpwaybill.list[i]['pictures'] = body.obj.cpwaybill.list[i].pics.split("##").filter(titem => titem != '');
                        }
                    }

                    me.order = body.obj;
                    if (body.obj.cpwaybill) {
                        me.waybillCurrent = Constants.waybillSteps[body.obj.cpwaybill.state + ""];
                    }
                    me.current = Constants.xiapiOrderSteps[me.order.orderStatus];
                } else {
                    me.errorMessage(body.info);
                }
                me.hideLoading();
            }, response => {
                me.loading = false;
                me.hideLoading();
            });

        },
        cancel: function() {
            this.show = false;
            this.$emit('cancel');
        }

    }
}
</script>
<style>
.orderdetailinfo,
.orderdetailinfo li {
    list-style: none;
}
</style>